export const states = {
	ConnectorEdit: 'connectors-edit',
	ConnectorCreate: 'connectors-new',
	ConnectorDuplicate: 'connectors-duplicate',
	ChartSelect: 'charts-select',
	ChartEdit: 'charts-edit',
	ChartVisualization: 'charts-view',
	DashboardCreate: 'new-dashboards',
	DashboardEdit: 'dashboards-edit',
	DashboardCarousel: 'dashboards-carousel',
	DashboardVisualization: 'dashboards-view',
	DatablockList: 'datablocks',
	DatablockEdit: 'datablocks-edit',
	DatablockCreate: 'datablocks-new',
	DatablockDuplicate: 'datablocks-duplicate',
	DatablockFromDatablock: 'datablocks-fromDatablock',
	DatablockFromEntity: 'datablocks-fromEntite',
	DepotList: 'depot-list',
	DepotEdit: 'depots-edit',
	DepotCreate: 'depots-new',
	DepotDuplicate: 'depots-duplicate',
	DepotV1ListCreateEntity: 'deprec-depot-list',
	DepotFromConnector: 'depots-fromConnector',
	EntityCreate: 'entites-new',
	EntityEdit: 'entites-edit',
	EntityDuplicate: 'entites-duplicate',
	EntityList: 'entity-list',
	ExportDatablockFromList: 'from-datablock-list',
	ExportTemplateList: 'export-template-list',
	ExportTemplateEdit: 'export-template-edit',
	ExpositionsList: 'expositions',
	ExpositionCreate: 'exposition-new',
	ExpositionView: 'exposition-view',
	ExpositionEditColumns: 'exposition-edit-columns',
	ExpositionEditApi: 'exposition-edit-api',
	ExpositionInitMigration: 'exposition-init-migration',
	ExpositionListMigration: 'expositions-migrate',
	ExpositionHistory: 'exposition-history',
	ExpositionDataSimulator: 'exposition-data-simulator',
	ExpositionFromDatablockList: 'exposition-from-datablock-list',
	ExpositionFromDatablockView: 'exposition-from-datablock-view',
	GridSelect: 'grids-select',
	GridEdit: 'grids-edit',
	GridVisualization: 'grids-view',
	HdHome: 'home',
	GdHome: 'gd-home',
	MapCreate: 'maps-new',
	MapEdit: 'maps-edit',
	MapVisualization: 'maps-view',
	MediaSelect: 'medias-select',
	MediaEdit: 'medias-edit',
	MediaVisualization: 'medias-view',
	Projects: 'projects',
	RankingList: 'rankings',
	RankingEdit: 'rankings-edit',
	RankingCreate: 'rankings-new',
	TimelineCreate: 'timelines-new',
	TimelineEdit: 'timelines-edit',
	TimelineVisualization: 'timelines-view',
};
